import cloneDeep from 'lodash.clonedeep';

import { eventCategoryLabels } from '../typeToName';
import {
  EventCategories,
  IEventChannel,
  ISubscription,
} from 'redux/reducers/subscriptions';
import { parsePriorityTypes } from './helpers';

const getSubscriptionForView = (subscription: ISubscription): any => {
  let someAllSelectedChannels = false;
  const eventCategories = Object.keys(eventCategoryLabels).reduce(
    (prev: any, category: EventCategories) => {
      const eventChannels = parsePriorityTypes(subscription);
      const channelsNumber = eventChannels.filter((channel: IEventChannel) =>
        channel?.eventCategories?.includes(category)
      );
      if (channelsNumber.length === 3) {
        prev.push(category);
        someAllSelectedChannels = true;
      }
      return prev;
    },
    []
  );

  const subscriptionClone = cloneDeep(subscription);
  if (someAllSelectedChannels)
    subscriptionClone.eventChannels.push({
      channelId: 'all' as any,
      eventCategories,
    });

  return subscriptionClone;
};

export default getSubscriptionForView;
